import React, { PureComponent } from 'react'
import { View, Image, Dimensions } from 'react-native'
import PageHeader from '../../Molecules/PageHeader'

import styled from 'styled-components/native'

import { translate } from '../../../services/translate'

const Container = styled(View)`
  flex: 1;
  flex-direction: column;
`

const Content = styled(View)`
  flex: 1;
  align-items: center;
  justify-content: center;
`

export default class BreakingNews extends PureComponent {
  render () {
    return (
      <Container>
        <PageHeader text={translate('breakingNews.screenHeader', 'BREAKING NEWS').toUpperCase()} />
        <Content>
          <Image
            style={{
              flex: 1,
              width: Dimensions.get('window').width - this.props.sidebarWidth,
              height: undefined,
              resizeMode: 'contain'
            }}
            source={{ uri: this.props.url }}
          />
        </Content>
      </Container>
    )
  }
}
